module.exports = __webpack_public_path__ + "img/d-like-empty-icon.03e3fa36.svg";